// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.idx_kos_wrapper {
  height: 100%;
  padding-top: 56px;
  padding-bottom: 64px;
  padding-left: 24px;
  padding-right: 24px;
  box-sizing: border-box;
  overflow-y: auto;
  background: #f5f5f5;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/Kitchen-OS/index.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb","sourcesContent":[".idx_kos_wrapper {\n  height: 100%;\n  padding-top: 56px;\n  padding-bottom: 64px;\n  padding-left: 24px;\n  padding-right: 24px;\n  box-sizing: border-box;\n  overflow-y: auto;\n  background: #f5f5f5;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
